import { memo } from "react";
import { Handle, Position } from "reactflow";
import {
  PlusCircleOutlined,
} from "@ant-design/icons";
import "./ButtonAdd.scss";
import { useSidebar } from "../../SidebarFlow/context";

const ButtonAdd = memo((props) => {
  const { openSidebar } = useSidebar();
  const onEdgeClick = () => {
    openSidebar({
      id: "addNode",
      type: "context_output",
      originType: "responseNode",
      dataNode: props,
    });
  };

  return (
    <>
      <Handle type="target" position={Position.Left} />
      <button
        ref={props.buttonRef}
        onClick={onEdgeClick}
        className={"add-button-node"}
      >
        <PlusCircleOutlined />
      </button>
    </>
  );
});

export default ButtonAdd;
